// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","form":"styles_form__F14Pu","container":"styles_container__xJ_M_","submit":"styles_submit__qSq_v","wrapper":"styles_wrapper__SOFbK"};